@if (value) {
  <div class="text-accent-red text-sm text-start">
    <ul>
      <li
        class="block"
      [ngClass]="{
        'text-primary': value.match('^(?=.*[A-Z])')
      }"
        >
        {{ "NEW_PASSWORD.CRITERIA.UPPERCASE" | translate }}
      </li>
      <li
        class="block"
      [ngClass]="{
        'text-primary': value.match('(?=.*[a-z])')
      }"
        >
        {{ "NEW_PASSWORD.CRITERIA.LOWERCASE" | translate }}
      </li>
      <li
        class="block"
      [ngClass]="{
        'text-primary': value.match('(?=.*[!@#$%^&*])')
      }"
        >
        {{ "NEW_PASSWORD.CRITERIA.SPECIAL" | translate }}
      </li>
      <li
        class="block"
      [ngClass]="{
        'text-primary': value.match('.{8,}')
      }"
        >
        {{ "NEW_PASSWORD.CRITERIA.LENGTH" | translate }}
      </li>
    </ul>
  </div>
}
